import type { ReactNode } from 'react';

export interface EventFactTileProps {
  /** Icon or avatar shown in the 44px square on the left. */
  icon: ReactNode;
  label: string;
  value: ReactNode;
  /** Optional smaller line under the value (e.g. the end date of an overnight event). */
  note?: string;
}

/**
 * One fact in the event detail page's facts strip (Date, Time, Location,
 * Organizer): a tinted icon square beside an uppercase label and its value.
 */
export function EventFactTile({ icon, label, value, note }: EventFactTileProps) {
  return (
    <div className="flex items-start gap-3">
      <span className="bg-green/10 text-dkgreen flex size-11 shrink-0 items-center justify-center rounded-xl">
        {icon}
      </span>
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="text-subtext text-xs font-medium tracking-[0.5px] uppercase">{label}</span>
        <span className="text-navy text-[0.9375rem] font-semibold">{value}</span>
        {note && <span className="text-subtext text-xs">{note}</span>}
      </div>
    </div>
  );
}
